<div class="container">
    <div class="inner-title text-center">
        <h3>{{ product_name}}</h3>
        <ul>
            <li><a routerLink="/">Home</a></li>
            <li><i class='bx bxs-chevron-right'></i></li>
            <li>{{ product_name}}</li>
        </ul>
    </div>
</div>